export default __webpack_public_path__ + "static/media/790651356544237618.27bffd7d.png";